import { isIreland } from 'src/lib/countryConfig';
import { PricingTerms } from 'src/pages/AddMerchantPage/components/ServiceType';

const GBContractTerms = [
    {
        label: '12 Months',
        online: true,
        value: PricingTerms.O12_MONTHS,
        numberOfMonths: 12,
    },
    {
        label: '18 Months',
        online: true,
        value: PricingTerms.O18_MONTHS,
        numberOfMonths: 18,
    },
    {
        label: 'Custom Term',
        online: true,
        value: PricingTerms.CUSTOM,
        numberOfMonths: 0,
    },
];

const IEContractTerms = [
    {
        label: '12 Months',
        online: true,
        value: PricingTerms.O12_MONTHS,
        numberOfMonths: 12,
    },
    {
        label: '24 Months',
        online: true,
        value: PricingTerms.O24_MONTHS,
        numberOfMonths: 24,
    },
    {
        label: '36 Months',
        online: false,
        value: PricingTerms.O36_MONTHS,
        numberOfMonths: 36,
    },
    {
        label: '48 Months',
        online: false,
        value: PricingTerms.O48_MONTHS,
        numberOfMonths: 48,
    },
    {
        label: 'Custom Term',
        online: true,
        value: PricingTerms.CUSTOM,
        numberOfMonths: 0,
    },
];
export const contractTerms = isIreland ? IEContractTerms : GBContractTerms;
